import TeaserCollection from 'collections/properties/teaserCollection';
import {Model} from 'backbone';

export default Model.extend({
    idAttribute: 'uuid',
    initialize(data) {
        this.set('teasers', new TeaserCollection(data.teasers));
    },
    toJSONWithCids() {
        return Object.assign({}, this.toJSON(), {teasers: this.get('teasers').toJSONWithCids()});
    },
});
